module.exports = __webpack_public_path__ + "img/Settings.6a72ecb1.svg";